import Router from '../../../router'

function getToday () {
  var now = new Date()
  var dd = String(now.getDate())
  var mm = String(now.getMonth() + 1)
  var yyyyNow = now.getFullYear()
  if (mm.length < 2) mm = '0' + mm
  if (dd.length < 2) dd = '0' + dd
  var startDateConst = yyyyNow + '-' + mm + '-' + dd
  return startDateConst
}

function getEndDate () {
  var now = new Date()
  var oneYr = new Date()
  oneYr.setFullYear(now.getFullYear() + 1)
  var dd = String(oneYr.getDate())
  var mm = String(oneYr.getMonth() + 1)
  var yyyyNextYear = oneYr.getFullYear()
  if (mm.length < 2) mm = '0' + mm
  if (dd.length < 2) dd = '0' + dd
  var endDateConst = yyyyNextYear + '-' + mm + '-' + dd
  return endDateConst
}

// var now = new Date()
// var oneYr = new Date()
// oneYr.setFullYear(now.getFullYear() + 1)
// var dd = String(oneYr.getDate())
// var mm = String(oneYr.getMonth() + 1)
// var yyyyNextYear = oneYr.getFullYear()
// var yyyyNow = now.getFullYear()
// if (mm.length < 2) mm = '0' + mm
// if (dd.length < 2) dd = '0' + dd
//
// var startDateConst = yyyyNow + '-' + mm + '-' + dd
// var endDateConst = yyyyNextYear + '-' + mm + '-' + dd

function getTimeNow () {
  var now = new Date()
  var hour = (now.getHours() < 10) ? '0' + now.getHours() : now.getHours()
  var min = (now.getMinutes() < 10) ? '0' + now.getMinutes() : now.getMinutes()
  var timeNow = hour + ':' + min
  return timeNow
}

function gotoLogin(fromPage) {
  localStorage.clear()
  Router.push("/pages/login")
}

export {
  getToday,
  getEndDate,
  getTimeNow,
  gotoLogin

}

export const NEWPORT_CONST = {
  // API_URL: 'https://apidev-dot-newportapi.appspot.com', // apidev
  // CLIENT_ID: '195efe600e8ee7550c43b93116820275', // apidev
  // CLIENT_SECRET: 'c9fc3a868a8388d84a8f6058b3cebcc3', // apidev
  // GOOGLE_ID: '836185144066-ob44bq3uacgipc77d0qesvqfkln6pap8.apps.googleusercontent.com', // apidev
  // FACEBOOK_ID: '2174082689577848', // apidev
  // FACEBOOK_API_VERSION: 'v2.8' // apidev

  // API_URL: 'http://10.45.0.235:3000', // local
  // CLIENT_ID: '195efe600e8ee7550c43b93116820275', // local
  // CLIENT_SECRET: 'c9fc3a868a8388d84a8f6058b3cebcc3', // local
  // GOOGLE_ID: '836185144066-ob44bq3uacgipc77d0qesvqfkln6pap8.apps.googleusercontent.com', // local
  // FACEBOOK_ID: '2174082689577848', // local
  // FACEBOOK_API_VERSION: 'v3.1' // local

  API_URL: 'https://api.thenewport.co', // PROD
  CLIENT_ID: '93ab93a49d971d5d6bcccf986b45e8d0', // PROD
  CLIENT_SECRET: '1410318f85cd0a3d73cc73ea6ac4ddb6', // PROD
  GOOGLE_ID: '1018829412965-m7947pvvkj7an8kt753gm5hhv0n9lohp.apps.googleusercontent.com', // PROD
  FACEBOOK_ID: '563539390705465', // PROD. Uncomment this when deploy to production
  FACEBOOK_API_VERSION: 'v2.8'
}



// WEBPACK FOOTER //
// ./src/views/base/shared/constants.js